import http from 'http/http';
import { api } from 'http/helpers';
import URLS from 'http/urls';
import { BannerCreateUpdateDto, BannerDto } from './types';

export const bannersApi = {
  fetchBanners() {
    return http.get<BannerDto[]>(api(URLS.banners.all));
  },
  fetchBannerImage(id: string) {
    return http.get<string>(api(URLS.banners.imageGet), {
      replacePathParams: { id },
    });
  },
  createBanner(data: BannerCreateUpdateDto, formData: FormData) {
    return http.post(api(URLS.banners.create), formData, {
      headers: {
        Accept: '*/*',
        'Content-type': 'multipart/form-data',
      },
      params: data,
    });
  },
  updateBanner(id: string, data: BannerCreateUpdateDto) {
    return http.put(api(URLS.banners.update), data, {
      replacePathParams: { id },
    });
  },
  deleteBanner(id: string) {
    return http.delete(api(URLS.banners.delete), {
      replacePathParams: { id },
    });
  },
};
